/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSystemNote } from '../fn/system-note/add-system-note';
import { AddSystemNote$Params } from '../fn/system-note/add-system-note';
import { deleteSystemNote } from '../fn/system-note/delete-system-note';
import { DeleteSystemNote$Params } from '../fn/system-note/delete-system-note';
import { getActive } from '../fn/system-note/get-active';
import { GetActive$Params } from '../fn/system-note/get-active';
import { getList_3 } from '../fn/system-note/get-list-3';
import { GetList_3$Params } from '../fn/system-note/get-list-3';
import { getSystemNote } from '../fn/system-note/get-system-note';
import { GetSystemNote$Params } from '../fn/system-note/get-system-note';
import { SystemNote } from '../models/system-note';
import { updateSystemNote } from '../fn/system-note/update-system-note';
import { UpdateSystemNote$Params } from '../fn/system-note/update-system-note';

@Injectable({ providedIn: 'root' })
export class SystemNoteService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getList_3()` */
  static readonly GetList_3Path = '/api/system/note';

  /**
   * Get List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getList_3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList_3$Response(params?: GetList_3$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemNote>>> {
    return getList_3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getList_3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList_3(params?: GetList_3$Params, context?: HttpContext): Observable<Array<SystemNote>> {
    return this.getList_3$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SystemNote>>): Array<SystemNote> => r.body)
    );
  }

  /** Path part for operation `addSystemNote()` */
  static readonly AddSystemNotePath = '/api/system/note';

  /**
   * Add System Note.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSystemNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSystemNote$Response(params: AddSystemNote$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemNote>> {
    return addSystemNote(this.http, this.rootUrl, params, context);
  }

  /**
   * Add System Note.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSystemNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSystemNote(params: AddSystemNote$Params, context?: HttpContext): Observable<SystemNote> {
    return this.addSystemNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemNote>): SystemNote => r.body)
    );
  }

  /** Path part for operation `getActive()` */
  static readonly GetActivePath = '/api/system/note/active';

  /**
   * Get Active.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActive()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActive$Response(params?: GetActive$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemNote>>> {
    return getActive(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Active.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getActive$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActive(params?: GetActive$Params, context?: HttpContext): Observable<Array<SystemNote>> {
    return this.getActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SystemNote>>): Array<SystemNote> => r.body)
    );
  }

  /** Path part for operation `getSystemNote()` */
  static readonly GetSystemNotePath = '/api/system/note/{systemNoteId}';

  /**
   * Get System Note.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSystemNote()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemNote$Response(params: GetSystemNote$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemNote>> {
    return getSystemNote(this.http, this.rootUrl, params, context);
  }

  /**
   * Get System Note.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSystemNote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemNote(params: GetSystemNote$Params, context?: HttpContext): Observable<SystemNote> {
    return this.getSystemNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemNote>): SystemNote => r.body)
    );
  }

  /** Path part for operation `updateSystemNote()` */
  static readonly UpdateSystemNotePath = '/api/system/note/{systemNoteId}';

  /**
   * Update System Note.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSystemNote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSystemNote$Response(params: UpdateSystemNote$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemNote>> {
    return updateSystemNote(this.http, this.rootUrl, params, context);
  }

  /**
   * Update System Note.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSystemNote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSystemNote(params: UpdateSystemNote$Params, context?: HttpContext): Observable<SystemNote> {
    return this.updateSystemNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemNote>): SystemNote => r.body)
    );
  }

  /** Path part for operation `deleteSystemNote()` */
  static readonly DeleteSystemNotePath = '/api/system/note/{systemNoteId}';

  /**
   * Delete System Note.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSystemNote()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSystemNote$Response(params: DeleteSystemNote$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemNote>> {
    return deleteSystemNote(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete System Note.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSystemNote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSystemNote(params: DeleteSystemNote$Params, context?: HttpContext): Observable<SystemNote> {
    return this.deleteSystemNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemNote>): SystemNote => r.body)
    );
  }

}
